import React from "react";
import {
    Box,
    Text,
    useDisclosure,
    Flex,
} from "@chakra-ui/react";
import { FiUserPlus } from "react-icons/fi";
import AddUserModal from "./AddUserModal";

export default function AddUserCard({ setUsers }) {
    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
        <>
            <Box
                bg="white"
                p={6}
                borderRadius="lg"
                border="1px solid"
                borderColor="gray.200"
                boxShadow="md"
                cursor="pointer"
                _hover={{ boxShadow: "lg", transform: "translateY(-2px)" }}
                transition="all 0.15s ease"
                onClick={onOpen}
            >
                <Flex
                    direction="column"
                    align="center"
                    justify="center"
                    gap={2}
                    h="100%"       
                    textAlign="center"
                >
                    <Box as={FiUserPlus} w="30vw" h="30vh" color="teal.500" />
                </Flex>
            </Box>


            <AddUserModal isOpen={isOpen} onClose={onClose} setUsers={setUsers} />
        </>
    );
}
